// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1dOmr","checkboxCol":"Table_checkboxCol__247cT","emailCol":"Table_emailCol__3WGe1","actionCol":"Table_actionCol__3QgG4"};